<!-- WMS AI助手 -->
<template>
    <div class="aiwms-page">
        <div class="chat-card">
            <!-- 头部 -->
            <div class="chat-header">
                <span class="chat-header-icon">✦</span>
                <span class="chat-header-title">WMS AI 助手</span>
                <span class="chat-header-sub">有问题，问一问</span>
            </div>
            <!-- 对话区 -->
            <div class="chat-body" ref="chatBody">
                <div v-if="messages.length === 0 && !loading" class="chat-empty">
                    <p class="chat-empty-icon">✦</p>
                    <p>请输入问题，向 WMS AI 提问</p>
                </div>
                <div v-for="(msg, index) in messages" :key="index" class="chat-item" :class="msg.role">
                    <div class="chat-bubble">{{ msg.content }}</div>
                </div>
                <div v-if="loading" class="chat-item assistant">
                    <div class="chat-bubble loading-bubble">
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                    </div>
                </div>
            </div>
            <!-- 输入区 -->
            <div class="chat-footer">
                <el-input v-model.trim="question" placeholder="请输入你的问题..." clearable
                    @keyup.enter.native="sendQuestion" class="chat-input"></el-input>
                <el-button type="primary" :loading="loading" @click="sendQuestion" class="chat-send-btn">发送</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AIwms',
    data() {
        return {
            // 提问内容
            question: '',
            // 问答记录
            messages: [],
            // 请求中状态
            loading: false,
        }
    },
    methods: {
        // 发送问题
        sendQuestion() {
            if (this.loading) {
                return
            }
            if (!this.question) {
                this.$message.warning('请输入问题！')
                return
            }
            const question = this.question
            this.messages.push({ role: 'user', content: question })
            this.question = ''
            this.scrollToBottom()
            this.loading = true
            // 调用WMS AI接口
            this.$api.wmsAiAsk({ question: question }).then(res => {
                this.messages.push({ role: 'assistant', content: this.formatReply(res) })
                this.scrollToBottom()
            }).finally(() => {
                this.loading = false
            })
        },
        // 处理接口返回内容，兼容字符串和对象
        formatReply(res) {
            if (typeof res === 'string') {
                return res
            }
            if (res && typeof res === 'object') {
                const field = ['content', 'reply', 'answer', 'data', 'message', 'text'].find(key => {
                    return res[key] !== undefined && res[key] !== null && res[key] !== ''
                })
                if (field) {
                    const value = res[field]
                    return typeof value === 'string' ? value : JSON.stringify(value)
                }
                return JSON.stringify(res)
            }
            return String(res)
        },
        // 滚动到底部
        scrollToBottom() {
            this.$nextTick(() => {
                if (this.$refs.chatBody) {
                    this.$refs.chatBody.scrollTop = this.$refs.chatBody.scrollHeight
                }
            })
        }
    }
}
</script>

<style lang="css" scoped>
.aiwms-page {
    padding: 10px;
    height: calc(100vh - 84px);
    box-sizing: border-box;
}

.chat-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    overflow: hidden;
}

/* 头部 */
.chat-header {
    display: flex;
    align-items: center;
    padding: 14px 20px;
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: #fff;
}

.chat-header-icon {
    font-size: 18px;
    margin-right: 8px;
}

.chat-header-title {
    font-size: 16px;
    font-weight: bold;
}

.chat-header-sub {
    margin-left: 12px;
    font-size: 12px;
    opacity: 0.85;
}

/* 对话区 */
.chat-body {
    flex: 1;
    overflow-y: auto;
    padding: 18px 20px;
    background: #f6f8fc;
}

.chat-empty {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #a0aec0;
    font-size: 14px;
}

.chat-empty-icon {
    font-size: 36px;
    margin: 0 0 8px;
    color: #a3b8ff;
}

/* 消息 */
.chat-item {
    display: flex;
    margin-bottom: 16px;
}

.chat-item.user {
    justify-content: flex-end;
}

.chat-item.assistant {
    justify-content: flex-start;
}

.chat-bubble {
    max-width: 70%;
    padding: 10px 14px;
    border-radius: 10px;
    font-size: 14px;
    line-height: 1.6;
    word-break: break-word;
    white-space: pre-wrap;
}

.chat-item.user .chat-bubble {
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: #fff;
    border-bottom-right-radius: 2px;
}

.chat-item.assistant .chat-bubble {
    background: #fff;
    color: #2d3748;
    border: 1px solid #e2e8f0;
    border-bottom-left-radius: 2px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

/* 思考中 */
.loading-bubble {
    display: flex;
    align-items: center;
    padding: 12px 16px;
}

.dot {
    width: 7px;
    height: 7px;
    margin-right: 5px;
    border-radius: 50%;
    background: #a0aec0;
    animation: aiwmsDot 1.2s infinite ease-in-out;
}

.dot:nth-child(2) {
    animation-delay: 0.2s;
}

.dot:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes aiwmsDot {
    0%, 80%, 100% {
        opacity: 0.3;
        transform: translateY(0);
    }
    40% {
        opacity: 1;
        transform: translateY(-4px);
    }
}

/* 输入区 */
.chat-footer {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-top: 1px solid #eef1f6;
    background: #fff;
}

.chat-input {
    flex: 1;
    margin-right: 12px;
}

.chat-send-btn {
    min-width: 76px;
}
</style>
